module.exports = false;

// Only Node.JS has a process variable that is of [[Class]] process
try {
 module.exports = Object.prototype.toString.call(global.process) === '[object process]' 
} catch(e) {}



//////////////////
// WEBPACK FOOTER
// ./~/detect-node/index.js
// module id = 438
// module chunks = 213534597649335